export function pageContext(meta) {
  if (!meta?.isConnected) throw new Error("The authorized page is no longer available. Reload the page.")
  return JSON.parse(meta.content)
}

export async function verifyWebmcpSession(meta, signal) {
  const expected = pageContext(meta)
  const endpoint = expected.mode === "recovery" ? "/conversation-access/current/webmcp" : "/webmcp/context"
  if (expected.endpoint !== endpoint) throw new Error("Invalid WebMCP session context.")
  const response = await fetch(endpoint, {
    credentials: "same-origin", cache: "no-store", redirect: "error",
    headers: { Accept: "application/json" }, signal
  })
  if (!response.ok) throw new Error("Access expired or was revoked. Reload and sign in again.")
  const actual = await response.json()
  if (JSON.stringify(actual) !== JSON.stringify(expected) || JSON.stringify(pageContext(meta)) !== JSON.stringify(expected)) {
    throw new Error("Account or roles changed. Reload before using WebMCP again.")
  }
  if (signal?.aborted) throw new Error("The call was cancelled.")
  return actual
}
